import { Box, useRecipe } from '@chakra-ui/react'
import { clsx } from 'clsx'
import { forwardRef } from 'react'

import { surfaceCardRecipe } from 'theme/recipes/surfaceCard.recipe'

import type { RecipeVariantProps } from '@chakra-ui/react'
import type { HTMLAttributes, ReactNode } from 'react'

type SurfaceCardRecipeVariants = RecipeVariantProps<typeof surfaceCardRecipe>

export type SurfaceCardVariant = NonNullable<SurfaceCardRecipeVariants['variant']>

interface SurfaceCardProperties extends HTMLAttributes<HTMLDivElement> {
  asChild?: boolean
  children: ReactNode
  variant?: SurfaceCardVariant
}

export const SurfaceCard = forwardRef<HTMLDivElement, SurfaceCardProperties>(
  ({ asChild = false, children, className, variant = 'default', ...properties }, reference) => {
    /* --- Section 1: Hooks --- */
    const recipe = useRecipe({ recipe: surfaceCardRecipe })

    /* --- Section 3: Derived Values --- */
    const styles = recipe({ variant })

    /* --- Section 6: Render --- */
    return (
      <Box
        {...properties}
        asChild={asChild}
        className={clsx(className)}
        css={styles}
        data-variant={variant}
        ref={reference}
      >
        {children}
      </Box>
    )
  }
)

SurfaceCard.displayName = 'SurfaceCard'
